<template>
  <div class="UploadImg">
    <div v-if="this.title" style="display: flex; justify-content: space-between; font-size: 13px">
      <div style="font-weight: bold;">{{this.titleText}}</div>
      <div>{{this.imgArr.length}}/{{ this.imgAmount }}</div>
    </div>
    <div class="felxBox">
      <div v-for="(item, index) in this.imgArr" :key="index" style="position: relative">
        <img :src="item.url" alt="" style="width: 70px; height: 70px; object-fit: cover; margin-right: 8px" @click="previewImg(index)">
        <div class="delete-icon" @click.stop="deleteImg(index)">x</div>
      </div>
      <div @click="onUploadImg" class="chooseImage" v-if="this.imgArr.length < this.imgAmount">
        <van-icon name="plus" size="20"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast, Dialog, icon, ImagePreview } from 'vant';
import {wx, wxConfig} from "@/libs/jssdk-util";

Vue.use(icon)
    .use(Toast)
    .use(Dialog)
    .use(ImagePreview)


export default {
  name: "uploadPhoto",

  props:{
    imgArr:{
      type: Array,
      default: []
    },

    imgAmount:{ //最多图片数量
      type: Number,
      default: 5
    },

    titleText:{
      type: String,
      default: '上传图片'
    },

    title:{
      type: Boolean,
      default: false
    }
  },

  data(){
    return{
      previewArr: [],
    }
  },

  methods:{
    previewImg(index){
      this.previewArr = this.imgArr.map(item =>{
        return item.url
      })
      ImagePreview({
        images: this.previewArr,
        startPosition: index,
      });
    },

    base64ImageSize(base64ImageStr) {
      const indexBase64 = base64ImageStr.indexOf('base64,');
      if (indexBase64 < 0) return -1;
      const str = base64ImageStr.substr(indexBase64 + 6);
      return (str.length * 0.75 / 1024 / 1024).toFixed(2);
    },

    onUploadImg(){
      let that = this
      wx.chooseImage({//选择图片
        count: that.imgAmount - that.imgArr.length,//限制上传图片的张数
        sizeType: ['compressed','original'], // 可以指定是原图还是压缩图，默认二者都有

        success: function(res) {
          let localIds = res.localIds
          // window.__wxjs_is_wkwebview  判断ios机型
          let i=0, length = localIds.length
          const getLocalImgData = () => {
            wx.getLocalImgData({
              localId: localIds[i],
              success: (res3) => {
                let localData = res3.localData
                // localData = localData.replace('jgp', 'jpeg');//iOS 系统里面得到的数据，类型为 image/jgp,因此需要替换一下
                if (localData.indexOf('data:image') == 0) {
                } else { //ios返回完整的base64, 安卓返回的没有头部 且其中可能包含换行符
                  localData = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                }
                let size = that.base64ImageSize(localData)
                if(size > 1){
                  return Toast('第' + (i+1) + '张图片大于1MB，已取消上传');
                }
                that.imgArr.push({
                  content:localData,
                  url:localData
                })

                i++
                if ( i < length){
                  setTimeout(()=>{
                    getLocalImgData()
                  },500)
                } else {
                  that.$emit('uploadimg',that.imgArr)
                }
              }
            })
          }
          getLocalImgData()

          // let i=0, length = localIds.length
          // const uploadImage = () => {
          //   wx.uploadImage({
          //     localId: localIds[i],
          //     isShowProgressTips:0,
          //     success: (res2) => {
          //       console.log(res2,'上传')
          //       that.imgArr.push(localIds[i])
          //       i++
          //       if ( i < length){
          //         setTimeout(()=>{
          //           uploadImage()
          //         },500)
          //       }
          //     }
          //   })
          // }
          // uploadImage()
        },

        fail(err) {
          Dialog.alert({
            title: '打开相册失败',
            message: err.errMsg
          })
        }
      });
    },

    deleteImg(index){
      this.imgArr.splice(index,1)
      this.$emit('uploadimg',this.imgArr)
    },
  },

  mounted(){
    wxConfig(['chooseImage', 'previewImage', 'getLocalImgData'])
    wx.error(function (err) {
      Dialog.alert({
        title: '微信配置失败，请刷新页面',
        message: JSON.stringify(err)
      })
    });
  }
}
</script>

<style lang="less" scoped>
.UploadImg{
  background: #fff;
  //padding: 15px 15px !important;

  .felxBox{
    display: flex;
    margin: 10px 0;
    flex-wrap: wrap;
  }


  .chooseImage{
    width: 70px;
    height: 70px;
    background: #ececec;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .delete-icon{
    height: 15px;
    background: #2e2e2e;
    width: 15px;
    text-align: center;
    line-height: 15px;
    color: #fff;
    border-radius: 222px;
    position: absolute;
    top: 0;
    right: 9px;
  }
}
</style>